import { render, staticRenderFns } from "./roleSetting.vue?vue&type=template&id=32a4f478&scoped=true&"
import script from "./roleSetting.vue?vue&type=script&lang=js&"
export * from "./roleSetting.vue?vue&type=script&lang=js&"
import style0 from "./roleSetting.vue?vue&type=style&index=0&id=32a4f478&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a4f478",
  null
  
)

export default component.exports